<template>
  <div class="page">
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="headimgurl" slot-scope="text, record">
        <img style="height: 32px" :src="record.headimgurl" alt="">
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="green">出价</a-tag>
        <a-tag v-if="record.status == 2" color="orange">生成订单</a-tag>
      </template>

      <template slot="bid" slot-scope="text, record">
        <router-link :to="'/tuanpai/goods/bidList?goods_id=' + record.id">出价记录</router-link>
      </template>
    </a-table>
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "手机号",
    dataIndex: "tel",
  },
  {
    title: "昵称",
    dataIndex: "nickname",
  },
  {
    title: "头像",
    scopedSlots: {
      customRender: "headimgurl",
    },
  },
  {
    title: "赢家",
    dataIndex: "win",
  },
  {
    title: "出价",
    dataIndex: "price",
  },
  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  }
];

export default {
  data() {
    return {
      columns,
      goods_id: null,
      list: []
    };
  },
  created() {
    this.goods_id = this.$route.query.goods_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get("/tuanpai/goods/getBidList", {
        params: {
          goods_id: this.goods_id
        },
      });

      if (r.status != 1) return;

      this.list = r.list;
    }
  },
};
</script>